import React from 'react';
import { ErrorIconContainer, StyledErrorIcon, ErrorTitle, ErrorText, ErrorDescriptionContainer } from './styled.js';

/* TODO: Add pseudo 'date' to top */
/* TODO: make a const map of error titles & descriptions based on type */
export const ErrorEntityBarChart = () => (
  <React.Fragment>
    <ErrorIconContainer height="275px">
      <StyledErrorIcon type="numContentPieces" />
    </ErrorIconContainer>
    <ErrorDescriptionContainer>
      <ErrorTitle>No results found.</ErrorTitle>
      <ErrorText>We couldn't find any results. Please make sure you've set your competitors or reach out to your Knotch associate</ErrorText>
    </ErrorDescriptionContainer>
  </React.Fragment>
);

export default ErrorEntityBarChart;
